<template>
  <ChatHost ref="host" />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChatHost from '@/components/chat/elements/chat-host.vue'
export default {
  name: 'chat-widget',
  components: {
    ChatHost
  },
  watch: {
    unreadCount() {
      console.log('Unread Count Changed', this.unreadCount)
      this.$emit('unreadCount', this.unreadCount)
    }
  },
  computed: {
    ...mapGetters('chat', ['unreadCount'])
  },
  methods: {
    ...mapActions('chat', ['quitChat']),
    async showChat(data) {
      this.$refs.host.showMessages(data)
    },
    async quit() {
      await this.quitChat()
    }
  },
  async beforeUnmount() {
    await this.quitChat()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/ChatWidget.vue